import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { NavbarContext } from "../../context";
import { deliverySteps } from "../../data/portfolioData";
import { CircleMark } from "../../components/Sketch";

export const Process = () => {
  const { ref, inView } = useInView({ threshold: 0.25 });
  const { ref: listRef, inView: listInView } = useInView({ threshold: 0.1, triggerOnce: true });
  const setPage = useContext(NavbarContext);

  useEffect(() => {
    if (inView) setPage("process");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <section
      ref={ref}
      id="process-page"
      className="process-section"
      aria-labelledby="process-heading"
    >
      <div className="container-wide">
        <h2 id="process-heading" className="section-heading">
          How I work.
        </h2>
        <p className="section-sub">
          Every project starts with the money, not the features. Most small businesses
          do not need an app. They need fewer lost customers and less manual work.
        </p>

        <ol ref={listRef} className="process-steps">
          {deliverySteps.map((item, i) => (
            <li
              key={item.step}
              className={`process-step fade-up${listInView ? " visible" : ""}`}
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <span className="process-step-name">
                <span className="process-step-index" aria-hidden="true">
                  {i + 1}
                  <CircleMark />
                </span>
                {item.step}
              </span>
              <h3 className="process-step-title">{item.title}</h3>
              <p className="process-step-body">{item.body}</p>
              <p className="process-step-artifact">
                <span>Leaves behind</span>
                {item.artifact}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
